export const llmAnswerSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Pacific Crest Properties — Los Angeles Real Estate Solutions",
  "about": {
    "@type": "Organization",
    "name": "Pacific Crest Properties",
    "url": "https://pacificcrestprop.com",
    "telephone": "(310) 596-6534",
    "email": "office@pacificcrestprop.com",
    "slogan": "From Coast to Crest — Real Estate Elevated",
    "areaServed": [
      "Los Angeles",
      "Pasadena",
      "West LA",
      "San Gabriel Valley"
    ]
  },
  "mainEntity": [
    {
      "@type": "Service",
      "name": "Fast, as-is property offer options",
      "provider": {
        "@type": "Organization",
        "name": "Pacific Crest Properties"
      },
      "areaServed": "Los Angeles",
      "url": "https://offer.pacificcrestprop.com",
      "description":
        "Options for homeowners exploring a fast, direct sale without listing, repairs, or showings."
    },
    {
      "@type": "Service",
      "name": "Renovation and home improvement services",
      "provider": {
        "@type": "Organization",
        "name": "Pacific Crest Properties"
      },
      "areaServed": "Los Angeles",
      "url": "https://renovation.pacificcrestprop.com",
      "description":
        "Renovation options including kitchens, bathrooms, flooring, and whole-home improvements."
    }
  ]
};
